import {Component, OnInit} from '@angular/core';
import {StepComponent} from '../../step/step.component';
import {StepService} from '../../services/step.service';
import {ActivatedRoute, Router} from '@angular/router';
import {StromcheckRequestService} from '../services/request.service';
import {ElementService} from '../../services/element.service';
import {PortalService} from '../../services/portal.service';
import {StromcheckAnfrage} from "../anfrage/stromcheck.anfrage";

/**
 * Special component for the start page of the chapter "eingabe". Only Textoutputs, no form.
 */
@Component({
  selector: 'app-stromcheck-eingabe-start',
  templateUrl: './eingabe.start.component.html'
})
export class EingabeStartComponent extends StepComponent implements OnInit {

  /**
   * current user data
   */
  anfrage: StromcheckAnfrage;
  /**
   * current portalId
   */
  portalId: string;

  /**
   * placeholder for portalname in welcome text
   */
  welcomePlaceholder: any = {};

  /**
   * link to next step
   */
  nextLink: string = "../../stromcheck/eingabe/basisinformationen/1";


  constructor(protected stepService: StepService, protected router: Router, protected route: ActivatedRoute, protected requestService: StromcheckRequestService,
              protected elementService: ElementService, protected portalService: PortalService) {
    super(stepService, router, elementService);
  }
  /**
   * @inheritDoc
   */
  ngOnInit() {
    super.ngOnInit();
    // get the current portalId
    this.portalId = this.portalService.currentPortalId;

    this.anfrage = this.requestService.getAnfrage();

    //init Placeholder
    if(this.portalService.getConfig('embed.portal.welcometext')) {
      this.welcomePlaceholder = {
        portalPlaceholder: ' ' + this.portalService.getConfig('embed.portal.welcometext')
      }
    }
    else {
      this.welcomePlaceholder = {
        portalPlaceholder: ''
      }
    }

    if(this.anfrage?.userInput?.gebaeudetyp !== null && this.anfrage?.userInput?.gebaeudetyp !== undefined) {
      this.route.queryParams.subscribe(params => {
          if(params?.step === 'basisinformationen2') {
            this.router.navigateByUrl(this.portalService.currentPortalId + '/stromcheck/eingabe/basisinformationen/2');
        }
      });
    }
  }

}
